import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import Modal, { MEDIUM_MODAL_WIDTH } from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { DangerousOutlined } from "@dextech-ai/dex-design-system/icons";
import Button from "@/components/Button";
import rem from "@/utils/rem";


export function CompanyExists({ setMessage, message }) {
	const pending = message?.includes('pending');
	const enrolled = message?.includes("sure organization is not already enrolled");
	const title = `Company ${pending?'Application':'Account'} Already Exists`;
	const visible = message?.length>0 && (pending || enrolled);
	return (
		<Modal width={MEDIUM_MODAL_WIDTH} visible={visible} close={setMessage}>
			<ModalHeader icon={<DangerousOutlined color="error" />}>
				<ModalTitle>{title}</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div
					style={{
						fontSize: rem(14),
						textAlign: "center",
					}}
				>
					<p className="message">{message}</p>
					<a href="https://support.sqtradex.com/">
						https://support.sqtradex.com/
					</a>
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<Button
						className="button--ghost"
						style={{ width: rem(80), marginLeft: rem(10) }}
						text="Okay, Got it"
						submit={setMessage}
					/>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
}
